import React from 'react';
import SEO from '../components/seo';
// import ProjectSliderMonto from '../components/projects/projectSliderMonto';
// import ProjectSliderLemosta from '../components/projects/projectSliderLemosta';
import ProjectSliderW from '../components/projects/projectSliderW';
import ProjectSliderLemochlo from '../components/projects/projectSliderLemochlo';
import ProjectSliderHero from '../components/projects/projectSliderHero';
// import ProjectSliderBook from '../components/projects/projectSliderBook';
import ProjectSliderTampack from '../components/projects/projectSliderTampack';
// import { HashLink } from 'react-router-hash-link';
// import $ from 'jquery';

const ProjectPage = () => {
  return (
    <>
      <SEO title="Our Projects" />
      <section className="projectVisual">
        <h1 className="visual--title">
          <span>Our</span> Projects
        </h1>
        <p className="visual--desc">
          全人類の健康をアップデートさせるべく
          <br />
          サイレンサーが展開するプロジェクト。
        </p>
      </section>
      <section className="projectWrap">
        {/* ////////////区切り線//////////// */}
        <div className="projectBox" id="p6">
          <h2 className="projectName">TAMPACK</h2>
          {/* <p className="projectCopy">戦う準備をしている人のために</p> */}
          <div className="projectSlider--wrap">
            <ProjectSliderTampack />
          </div>
          {/* <h3 className="projectOverview">完全予約制の広島のオアシス</h3>
          <h3 className="projectOverview">施術前カウンセリングシートとディスカッションで身体の声を聴く</h3>
          <h3 className="projectOverview">施術後にお送りするオーダーメイドレポート</h3> */}
          <h3 className="projectOverview">戦う準備をしている人のために</h3>
          <div className="projectText">
            <p>
              生産合理性、経済合理性。
              そんな言葉と引き換えに著しく低下したモノがある。
              それは食物が本来持っていたはずの栄養素。
            </p>
            <p>
              現代人はそれらを当たり前に口する生活の中で無自覚に真に必要な栄養さえも摂取出来なくなっている。
            </p>
            <p>
              そこで"全人類をゴキゲンへと導く"とミッションを掲げるサイレンサーが現代へ提示するあたらしい解答は「プロテイン」
            </p>
            <p>
              プロテイン。
              直訳すると「タンパク質」、古代ギリシャ語では「一番重要な物」と訳される。
            </p>
            <p>
              タンパク質不足+糖質過多＋脂肪酸不足＋ビタミン不足＋ミネラル不足で生まれた、サイレンサーが現代の社会問題として声を大にして警笛を鳴らし続けている「質的栄養失調」。
              このままの食文化では筋肉のみならず、脳、髪、爪、皮膚、血液、臓器に対する最適な栄養的回答は永遠に得られない。
              そこを日々の中で無理なく不足し栄養素を補っていけるのがこのプロテイン、通称TAMPACK(タンパック)。
            </p>
            <p>
              開発にあたり「普段、口にするそのモノの生産背景」まで深くリサーチする"トレーサビリティ概念"をベースに"ホンモノ"の材料に徹底的に拘り、３年の歳月を掛けてようやく完成。
            </p>
            <p>
              健康と気分。 もうこの２つは"人のせい"には出来ない。
              自らの手で心身を"ゴキゲンの領域"へ。 さぁ！TAMPACKを片手に「VS
              質的栄養失調」の闘いの幕を上げよう！
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a href="https://tampack.jp/" target="_blank" rel="noreferrer">
                Online Shop
              </a>
            </li>
          </ul>
        </div>
        {/* ////////////区切り線//////////// */}
        <div className="projectBox" id="p3">
          <h2 className="projectName">レモクロ</h2>
          {/* <p className="projectCopy">
            八重山クロレラと広島産レモンのみを使い、
            葉酸・ビタミン・アミノ酸など植物由来の栄養素がつまった食事に近いサプリメント、レモクロ。
            安心の国産・無添加。いらないものを引き、必要な栄養を摂り入れることで現代人の健康をアップデート。
          </p> */}
          <div className="projectSlider--wrap">
            <ProjectSliderLemochlo />
          </div>
          <h3 className="projectOverview">向き合え！自分と</h3>
          <div className="projectText">
            <p>
              誰かを愛した時、誰かを幸せにしたいと心から思った時、もっとも大切な事がある。
            </p>
            <p>それは"自分自身の健康状態"。</p>
            <p>
              その為に必要なのは膨大なネット情報検索や無責任な書き込みではなく、ただ静かに自分の内側に耳を傾け感じ決断する事のみ。
              現代の食物で補いきれないビタミン、ミネラル、アミノ酸。
              それらを日々慌ただしい生活の中でも気楽に取り込める様コンパクトな錠剤にしました。
            </p>
            <p>
              サイレンサーが掲げる「ゴキゲン」な心身は軽負担・最大効率の無添加サプリ「レモクロ」からはじまる。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://lemon-chlorella.com/"
                target="_blank"
                rel="noreferrer"
              >
                Online Shop
              </a>
            </li>
          </ul>
        </div>
        {/* ////////////区切り線//////////// */}
        <div className="projectBox" id="p4">
          <h2 className="projectName">HERO Feeling Salon</h2>
          <p className="projectCopy">
            CS60/オイルリラクゼーション+頭蓋仙骨法/よもぎ蒸し/RIFE
            LIFE/毛髪ミネラル検査。深いヒアリングから導き出される、日々の生活の中で万病の温床になっている身体の電子情報のエラーを最適化し、人間本来の自然治癒力と免疫機能をGOKIGENへ
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderHero />
          </div>
          {/* <h3 className="projectOverview"></h3> */}
          <h3 className="projectOverview">あたらしい心身ゼロ地点へ</h3>
          {/* <h3 className="projectOverview"></h3> */}
          <div className="projectText">
            <p>あたらしいZEROへ。</p>
            <p>
              一方的な価値観。一方的な情報。一方的なあり方。そんな無批判であまりに偏りすぎた思考が横たわる現代社会。
            </p>
            <p>
              窮屈で、その崩れた軸を失った身体バランスは心身への不調へと繋がっている。
              <br />
              ネガティブなニュースが連日報じられ日々の自分の大切な「上機嫌」の軸さえメディアにコントロールされてはいないだろうか？
            </p>
            <p>
              そうした日々の中で大きく偏ったマインドとフィジカルの座標軸は健やかなゼロ地点を遠く離れ、それは必ず様々な形でメッセージとして身体に現れる。
            </p>
            <p>過剰にはマイナスを、不足にはプラスを。</p>
            <p>HEROで整えられるのは身体の隔たった電子情報の最適化。</p>
            <p>
              それは原点回帰ではない。
              <br />
              あたらしくサスティナブルなZERO地点への着地のための軌道修正となる。
            </p>
            <p>わたしたちの未来は自身の内側にある。</p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/hero_feeling_salon/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
          </ul>
        </div>
        <div className="projectBox" id="p1">
          <h2 className="projectName">
            LEMON STAND HIROSHIMA / <br className="sp" />
            mon-to.9
          </h2>
          <p className="projectCopy">
            広島特産レモンを使用した上質なレモンサワーと丁寧にセレクトされたナチュラルワインを飲みながら「一つ上をいく本物の広島遊び」の起点となる酒場。
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderW />
          </div>
          <h3 className="projectOverview">
            昼と夜の広島観光活況情報発信基地。
          </h3>
          <div className="projectText">
            <p>
              酒場の“賑わい”は何処からやってくるのだろう？
              <br />
              美味しい食事、気の置けない友達etc...
              <br />
              理由を探れば人それぞれ多様な答えがそこにはある。
            </p>
            <p>
              レモスタとモントナイン。
              <br />
              昼と夜。
              <br />
              ２つの異なる側面を持つ店を”レモンサワーとナチュラルワイン”で繋いでみると似て非なる不思議な光景が見えてくる。
              <br className="sp" />
              昼の明るい表通りに一滴の闇を落とすレモンスタンド。
              <br className="sp" />
              夜の暗い繁華街に光降り注ぐ”夜の無料案内所”をも内包するモントナイン。
              <br className="sp" />
              街、そのエリアの既存の表情に敢えて当てた裏の概念により生じたその摩擦は常に自然な熱を孕んでいる。
            </p>
            <p>
              レモンサワーで生まれる対話と、ナチュラルワインではじまる思考があり、そこで得られる新しい刺激(傷)は個々の次のアクションへのステップになる可能性を秘めている。
            </p>
            <p>
              「その日、その場に居合わせた人との無理のない緩やかな繋がりと対話への渇きを潤す現代の酒場」として。
              <br className="sp" />
              更には、「内なる最適化された時間だけではない、その外側のコミュニティへの解放区」として。
              <br className="sp" />
              モントナインとレモスタには、これからの時代のそんな”健全なる社会的役割”を担うサードプレイスでありたいとの願いを込めている。
            </p>
            <p>
              着座のボックス席では避けて通れない「人と人との視えざる境界線」が曖昧で朧げになるオールスタンディングで繰り広げられる享楽と饗宴のCOUNTER
              PLACE。
            </p>
            <p>
              光と闇が互いを掻き消し合いながら存在する様にそこにある"時の流れ方が異なる二つの酒場"。
              <br className="sp" />
              グラスの底を覗き込めば無意識に偏っていた価値観のあたらしい一面が見えるかもしれない。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/lemon.stand.hiroshima/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                LEMON STAND HIROSHIMA
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/monto.nine/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                mon-to.9
              </a>
            </li>
            {/* <li>
              <a
                href="https://www.facebook.com/LEMON-STAND-%E5%BA%83%E5%B3%B6-1547321938737476/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li> */}
          </ul>
        </div>

        {/* <div className="projectBox" id="p1">
          <h2 className="projectName">mon-to.9</h2>
          <p className="projectCopy">
            広島レモンを使ったレモンサワーと広島県産生牡蠣の専門店「mon-to.9」。その他にも自然派ワインやジビエソーセージなど、本物だけにこだわり、選び抜かれたメニューが並ぶ一面ガラス張り4.5坪の立ち飲み屋。また、ただの立ち飲み屋ではなく、広島の特産品であるレモンと牡蠣を目当てに来た県外や海外の人に、広島の食や文化を発信する無料案内所&お土産屋でもある。
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderMonto />
          </div>
          <h3 className="projectOverview">
            あたりなレモンサワーとあたらない生牡蠣
          </h3>
          <h3 className="projectOverview">
            ゴエミヨやワカコ酒その他多数メディアにも掲載
          </h3>
          <h3 className="projectOverview">
            「1杯どうですか？」の紙をきっかけに始まる新たな繋がり
          </h3>
          <div className="projectText">
            <p>
              広島県産の無農薬レモンを使用したレモンサワーは、薄はりグラスにカチ割り氷、専用のサーバーとシロップと超強炭酸を使うこだわり。800円〜10,000円まで計7種あり、味はもちろん、ここでしか飲めないエンタメレモンサワーが売り。生牡蠣は広島県の清浄海域で育った無菌の当たらない牡蠣。広島が誇る日本一の生産量の２つを柱に、その他ナチュラルワインやクラフトビール、ジビエソーセージなど自分達が本当に美味しく身体に良いと思うものだけをメニューに並べる。また、ガラス張りの店内から掲げる「1杯どうですか？」という紙を通して店前を通るお客さんともコミュニケーションを楽しむスタイルは、4.5坪の中に20人以上の人を引き寄せる程。さらに、お客さんがお客さんを呼び込み、一体感あふれるmon-to.9ではいつも新しい繋がりが生まれる。こだわりのメニューや4.5坪が魅せる盛り上がりはゴエミヨやワカコ酒などのメディアにも多数掲載。
            </p>
          </div>
          <h3 className="projectOverview">
            ただの立ち飲みではなく、広島の食や文化の発信地
          </h3>
          <h3 className="projectOverview">
            広島を楽しんでもらうための無料案内と新しい広島土産の提案
          </h3>
          <div className="projectText">
            <p>
              オープン当初からmon-to.9は飲食店ではなく、美味しいレモンサワーが飲める「無料案内所&お土産屋」だと公言してきた。広島のレモンや生牡蠣を求めて来店される県外や海外からのお客さんに、広島をもっと楽しんでもらいたいという思いから、広島の食や文化を発信する場所にしたい、新しい広島土産を提案したいと。美味しいレモンサワーと生牡蠣を口にしながら、広島の美味しいお店や観光スポットを紹介。また、思い出に残る新しい広島土産の「レモクロ」や「金のチョコ」や「オリジナルTシャツ」なども提案している。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/monto.nine/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/monto9monto9/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li>
          </ul>
        </div> */}
        {/* ////////////区切り線//////////// */}
        {/* <div className="projectBox" id="p2">
          <h2 className="projectName">LEMON STAND HIROSHIMA</h2>
          <p className="projectCopy">
            昼は座り、夜は立ちと２つの顔を持つ「レモンスタンド広島」。レモンサワーと生牡蠣に加え、3種のカレーと3種の副菜があいがけになった広島カレープレートが追加。また、共通言語を持ったコミュニティづくりを目的とした、健康交流会や参加型イベント、飲食店とのコラボイベントなどを実施。お客さんのサードプレイスとなれるように居心地の良さを追求。
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderLemosta />
          </div>
          <h3 className="projectOverview">座りと立ちの2つの顔</h3>
          <h3 className="projectOverview">3種のあいがけ広島カレープレート</h3>
          <h3 className="projectOverview">TV、雑誌など多数メディア掲載</h3>
          <div className="projectText">
            <p>
              1号店「mon-to.9」のレモンサワーと生牡蠣などに加え、3種のカレーと3種の副菜をあいがけにした広島カレープレートが追加。カレープレートにも広島レモンと牡蠣の醤を使用しており、広島の特産品をカレーで表現した。昼は座りでゆっくりお酒やカレーを楽しめ、夜は照明が薄暗く落ち着いた雰囲気の立ち飲みに変わる。昼と夜で雰囲気が変わるレモンスタンド広島は県内だけに限らず、県外や海外からのお客さんも多い。また、自然派ワインも種類豊富に取り揃えており、自然派ワインを求めて来店される方も多い。ランチやカレー特集などでメディアにも多数掲載。
            </p>
          </div>
          <h3 className="projectOverview">
            お客さんのサードプレイスになれるような雰囲気作り
          </h3>
          <h3 className="projectOverview">
            食や健康など、共通言語を持ったコミュニティ作り
          </h3>
          <div className="projectText">
            <p>
              家庭や職場以外に自分の居場所を作る事が精神的な健康のアップデートに繋がるという思いから、レモンスタンド広島はお客さんのサードプレイスになれるように居心地の良さを追求。また、共通言語を持ったコミュニティ形成が社会との繋がりを感じられるのではないか、社会的健康のアップデートになるのではないかという思いから、健康交流会や食を通じた参加型イベント、飲食店とのコラボイベントなどを実施。mon-to.9同様、ただの飲食店ではなく、居心地の良さの追求や共通言語を持つコミュニティ作りなど、人々の健康アップデートをより意識した場所でもあるのがレモンスタンド広島。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/lemon.stand.hiroshima/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/LEMON-STAND-%E5%BA%83%E5%B3%B6-1547321938737476/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li>
          </ul>
        </div> */}
        {/* ////////////区切り線//////////// */}
        {/* <div className="projectBox" id="p5">
          <h2 className="projectName">本屋『檸檬』</h2>
          <p className="projectCopy">
            レモンサワーとナチュラルワインを飲みながら、読書と対話を丁寧に重ねたい人の為の本屋。
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderBook />
          </div>
          {/* <h3 className="projectOverview">完全予約制の広島のオアシス</h3>
          <h3 className="projectOverview">施術前カウンセリングシートとディスカッションで身体の声を聴く</h3>
          <h3 className="projectOverview">施術後にお送りするオーダーメイドレポート</h3>
          <p>
              読書を愛している。読書は孤独をくれる。愛おしい孤独を。孤独の中で自分と向き合うことで心は育つ。心という木に檸檬の実が実る。精神の健康への第一歩となる。そんな体験を語る場を持つことで社会的な健康を獲得することに繋げる。
              <br />
              <br />
              同じ本を読んでいる人との出会いは感動を呼び起こす。つい話したくなる。自分と別の本を読んでいる人との出会いは好奇心を抱かせる。読んでみようかなと思ってしまう。ただ、そこにある一冊の本より、誰かが読んだ本に魅力を感じる。そんな体験を愛している。だから新刊書店『檸檬』はこの体験を創り出す。
              <br />
              <br />
              創り出す方法を突き詰めると、本を売らない選択になった。本と本の物々交換。お客さんは本を選ぶ体験と、本を並べる体験の両方を楽しめる。本が好きな人にとっては一冊の本を選ぶことも、一冊の本を手放すことも大切な瞬間になる。そんな大切な瞬間を実りあるものにするために、檸檬爆弾カードを書いてもらう。書く内容は、読んだ感想でもいい、読んだ時の心境でもいい、どんな人に送りたいかでもいい。とにかく思いを綴って欲しい。例えば僕なら失恋した時に読んで救われたゲーテの『若きウェルテルの恋人』を恋に悩む人に送りたいとか。梶井基次郎の『檸檬』に出てくる「丸善を破壊する黄金色の爆弾」という妄想のように、いつの日か誰かが見つけた時のために、「思い」を檸檬爆弾に載せて本に馳せてもらいたい。
              <br />
              <br />
              読書の体験を語る場として、檸檬サワーとナチュラルワインのバーも用意している。新刊書店『檸檬』で提供する檸檬サワーは、「身体が弱く若くして亡くなった梶井基次郎を健康にする」をコンセプトに作られている。彼が療養で訪れた伊豆の地酒を使い、日本一の生産量を誇る広島の瀬戸内檸檬を皮ごと漬け込んでいる。それでもまだ完成には至らない。日々、研究し、研鑽を重ね進化する檸檬サワーは梶井基次郎だけでなく、お客さんまでも健康にするに違いない。
              <br />
              <br />
              ナチュラルワインは葡萄の栽培、醸造のワインができる過程の中で、一切科学的なものを排除し、葡萄が本来の持つ力のみで作られている。その歴史は8000年前にも遡る。受け継がれるナチュラルワインは何百年前の文豪たちも愛したワインに通じるものがある。自分が読む小説の舞台や著者の出身地とナチュラルワインの生産地をペアリングして楽しんで読んでもらいたい。きっと何か感じるものがそこにある。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/honya_lemon/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
          </ul>
        </div> */}
      </section>
    </>
  );
};

export default ProjectPage;
